import styled from "styled-components";
import {down, up} from "styled-breakpoints";

export const Wrapper = styled.div`
    ${up("md")} {
        //padding-top: 70px;
    }
`
export const PaymentSuccessContainer = styled.div`
    font-family: Halenoir;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    background: white;
    padding: 40px 20px 20px;
    position: relative;

    .sticky-checkout-btn {
        width: 100%;
        border-radius: 36px;
        padding: 12px;
        font-weight: 600;
        font-size: 1em;
        background: #0b9c07;
        border: 1px solid #0b9c07;
        color: white;

        &:disabled {
            background: #cccccc;
            border-color: #cccccc;
            color: #666666;
        }
    }
    ${down("md")} {
        .mobile-sticky-checkout {
            display: block;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            padding: 12px 16px;
            box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
            z-index: 1000;
            border-top: 1px solid #e0e0e0;
        }

        padding: 30px 20px 80px;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 400px;
    width: 100%;
    //flex: 1;
`;

export const TimeDisplay = styled.div`
    color: #666;
    font-size: 14px;
    margin-bottom: 40px;
    font-weight: 500;
`;

export const Title = styled.h1`
    color: #2d3748;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 30px;
    line-height: 1.3;
`;

export const OrderStatusIcon = styled.div`
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
`;

export const SuccessMessage = styled.div`
    background: #f0fff4;
    border: 1px solid #9ae6b4;
    border-radius: 12px;
    padding: 25px 20px;
    margin-bottom: 40px;
    width: 100%;
`;

export const CongratulationsText = styled.p`
    color: #000000;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    line-height: 1.4;
`;

export const ConfirmationText = styled.p`
    color: #4a5568;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
`;

